import { Component } from '@angular/core';

/** The shared Workspace owns chrome and docking; this page owns discovery content. */
@Component({
  selector: 'app-prospect-workspace',
  templateUrl: './prospect-workspace.component.html',
  styleUrls: ['./prospect-workspace.component.css'],
})
export class ProspectWorkspaceComponent {}
